import React from 'react';
import { useCartState } from '../../../../contexts/cart';
import { useFilterState } from '../../../cap';
import { useAnalyticsContext } from '../../../../config/GoogleTagManagerEvents';
import useAnalytics from '../../../../hooks/analytics/useAnalytics';
import useMedia from '../../../../hooks/useMedia';
import { ChooseAStoreView } from './ChooseAStoreView';

export const ChooseAStoreViewWrapper = props => {
    const [cartState] = useCartState();
    const analyticEvents = useAnalyticsContext();
    const [{ payloadEcommerceLocationActionAnalytics }] = useAnalytics();
    const mediaType = useMedia();
    const {
        makeSelectedClicked,
        handleBackClickMobile,
        mobileCloseButton,
        onStoreDetailsClick,
        mapToggle,
        storesData,
        selectedStoreValue,
        setSelectedStoreValue,
        storeDetailData,
        setIsBestMatch,
        isBestMatch,
        handleToggle,
        handleChooseThisStoreClick,
        onStoreDetailClick,
        saveStoreDetails,
        setOnStoreDetailsClick,
        handleChooseStoreFromStoreDetails,
        handleMapToggle,
        handleCloseClick,
        nextAvailableStartDate,
        currentLocation,
        pickupStoreFooterClass,
        pickupStoreHeaderClass,
        mapMobileClass,
        variant,
        pickupStoreDrawerHeading,
        pickupStoreDrawerFooter,
        showAvailableStartDate,
        showInDrawerForTablet,
        showMonochromaticMap,
        storeDetailsClassName,
        storesClassName,
        companyId,
        triggerStoreModalAnalytics,
        showShimmer,
        localUnavailableCartItemsPerPc,
        showDrawerInRight,
        localStartDate
    } = props;

    return (
        <>
            <ChooseAStoreView
                makeSelectedClicked={makeSelectedClicked}
                handleBackClickMobile={handleBackClickMobile}
                mobileCloseButton={mobileCloseButton}
                onStoreDetailsClick={onStoreDetailsClick}
                mapToggle={mapToggle}
                storesData={storesData}
                selectedStoreValue={selectedStoreValue}
                setSelectedStoreValue={setSelectedStoreValue}
                storeDetailData={storeDetailData}
                mediaType={mediaType}
                setIsBestMatch={setIsBestMatch}
                isBestMatch={isBestMatch}
                handleToggle={handleToggle}
                handleChooseThisStoreClick={handleChooseThisStoreClick}
                onStoreDetailClick={onStoreDetailClick}
                saveStoreDetails={saveStoreDetails}
                setOnStoreDetailsClick={setOnStoreDetailsClick}
                handleChooseStoreFromStoreDetails={handleChooseStoreFromStoreDetails}
                handleMapToggle={handleMapToggle}
                handleCloseClick={handleCloseClick}
                nextAvailableStartDate={nextAvailableStartDate}
                cartState={cartState}
                analyticEvents={analyticEvents}
                payloadEcommerceLocationActionAnalytics={payloadEcommerceLocationActionAnalytics}
                currentLocation={currentLocation}
                pickupStoreFooterClass={pickupStoreFooterClass}
                pickupStoreHeaderClass={pickupStoreHeaderClass}
                mapMobileClass={mapMobileClass}
                variant={variant}
                pickupStoreDrawerHeading={pickupStoreDrawerHeading}
                pickupStoreDrawerFooter={pickupStoreDrawerFooter}
                useFilterState={useFilterState}
                showAvailableStartDate={showAvailableStartDate}
                showInDrawerForTablet={showInDrawerForTablet}
                showMonochromaticMap={showMonochromaticMap}
                storeDetailsClassName={storeDetailsClassName}
                storesClassName={storesClassName}
                companyId={companyId}
                triggerStoreModalAnalytics={triggerStoreModalAnalytics}
                showShimmer={showShimmer}
                localUnavailableCartItemsPerPc={localUnavailableCartItemsPerPc}
                showDrawerInRight={showDrawerInRight}
                localStartDate={localStartDate}
            />
        </>
    );
};
